document.addEventListener('DOMContentLoaded', function () {
    console.log('cart-recommendations.js loaded');

    window.initCartDrawerSwiper?.();
    window.initUpsellsSwiper?.();
    toggleCartDrawerRecommendations();

    // Wait for subscribe function to be available
    function waitForSubscribe() {
        if (typeof subscribe === 'function') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                console.log('[cartUpdate] Drawer content updated');

                requestAnimationFrame(() => {
                    window.initCartDrawerSwiper?.();
                    window.initUpsellsSwiper?.();
                    setTimeout(() => {
                        window.initCartDrawerSwiper?.();
                        window.initUpsellsSwiper?.();
                        toggleCartDrawerRecommendations();
                    }, 0);
                });
            });
        } else {
            setTimeout(waitForSubscribe, 100);
        }
    }

    waitForSubscribe();

    function toggleCartDrawerRecommendations() {
        const cartDrawerRecommendToggle = document.querySelector('.drawer__recommendations-toggle__button');
        if (cartDrawerRecommendToggle) {
            const carouselRecommendations = document.querySelector('#cart-drawer-recommendations .drawer__recommendations-wrapper');
            const cartRecommendationsHeight = document.querySelector('#cart-drawer-recommendations .drawer__recommendations-content') ? document.querySelector('#cart-drawer-recommendations .drawer__recommendations-content').offsetHeight : 150;
            document.documentElement.style.setProperty('--cart-recommendations-height', `${cartRecommendationsHeight}px`);
            cartDrawerRecommendToggle.addEventListener('click', function () {
                cartDrawerRecommendToggle.classList.toggle('m-showed');
                carouselRecommendations.classList.toggle('m-hidden');
                // initCartDrawerSwiper();
            });
        }
    }
});

function initUpsellsSwiper() {
    
    const swiperContainer = document.querySelector(".drawer__upsells .swiper-container");

    if (swiperContainer && !swiperContainer.classList.contains('swiper-container-initialized')) {
        const skeleton = document.querySelector('[data-upsells-skeleton]');
        if (skeleton) skeleton.style.display = 'none';


        new Swiper(swiperContainer, {
            spaceBetween: 20,
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.1,
                }
            },
            navigation: {
                nextEl: ".swiper-button-next--cart-drawer",
                prevEl: ".swiper-button-prev--cart-drawer",
            },
        });
    } else {
        return;
    }
}

function initCartDrawerSwiper() {

    const swiperContainer = document.querySelector("#cart-drawer-recommendations .swiper-container");

    if (swiperContainer && !swiperContainer.classList.contains('swiper-container-initialized')) {
        const skeleton = document.getElementById('cart-drawer-recommendations-skeleton');
        if (skeleton) skeleton.style.display = 'none';


        new Swiper(swiperContainer, {
            spaceBetween: 20,
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 1.1,
                }
            },
            navigation: {
                nextEl: ".swiper-button-next--cart-drawer",
                prevEl: ".swiper-button-prev--cart-drawer",
            },
        });
    } else {
        return;
    }
}